import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const skipSpinner = req.headers.has('X-Skip-Spinner');

    // Remove the custom header before sending to backend
    const requestToSend = skipSpinner
      ? req.clone({ headers: req.headers.delete('X-Skip-Spinner') })
      : req;

    if (!skipSpinner) {
      this.spinnerService.show();
    }

    return next.handle(requestToSend).pipe(
      finalize(() => {
        if (!skipSpinner) {
          this.spinnerService.hide();
        }
      })
    );
  }
}
